// extracted by mini-css-extract-plugin
module.exports = {"big":"styles_big__fOFOC","imageOverlay":"styles_imageOverlay__dStRc","title":"styles_title__6YVeX","sport":"styles_sport__wlbfa"};